import React from "react";
import "../../assets/scss/components/generic/search.scss";
import DeviceContext from "../service/indentifyDevice";

export interface SearchProps {
  searchList: Array<any>;
  searchKey: string;
  onSearch: (filteredData: Array<any>, sText?: string, type?: string) => void;
  classname?: string;
  placeholder?: string;
}

const Search: React.FC<SearchProps> = (props) => {
  const searchEle = React.useRef<HTMLInputElement>(null);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    // Variable to hold the original version of the list
    let currentList = [];
    // Variable to hold the filtered list before putting into state
    let newList = [];

    // If the search bar isn't empty
    if (e.target.value !== "") {
      // Assign the original list to currentList
      currentList = props.searchList;
      const keysArray = props.searchKey.split(";");

      // Use .filter() to determine which items should be displayed
      // based on the search terms
      newList = currentList.map((g: Array<any>) => {
        const result = g.filter((item) => {
          // change current item to lowercase
          // If there are multiple keys in array, then find the key that has data
          // if no key has data, then take the last key
          const key: string =
            keysArray.find((k) => item[k]) || keysArray[keysArray.length - 1];
          // !item[key] && console.log(key);
          const lc = item[key] ? item[key].toLowerCase() : "";
          // change search term to lowercase
          const filter = e.target.value.toLowerCase();
          // check to see if the current list item includes the search term
          // If it does, it will be added to newList. Using lowercase eliminates
          // issues with capitalization in search terms and search content
          return lc.includes(filter);
        });
        return result;
      });
    } else {
      // If the search bar is empty, set newList to original task list
      newList = props.searchList;
    }
    // Set the filtered state based on what our rules added to newList
    props.onSearch(newList, e.target.value, "search");
  }

  function reset() {
    let ele = document.getElementById("tableDataSearchEle") as HTMLInputElement;
    ele.value = "";
    props.onSearch(props.searchList, "", "search");
  }

  return (
    <div className="search_form">
      <button className="i_search">
        <i className="edel-icon-search"></i>
      </button>
      <input
        id="tableDataSearchEle"
        ref={searchEle}
        autoFocus
        type="text"
        className={props.classname}
        onChange={handleChange}
        placeholder={
          props.placeholder
            ? props.placeholder
            : DeviceContext().isMobile
            ? "Eg “INFYJAN20FUT”"
            : "Search for scrip name, eg “INFYJAN20FUT”"
        }
        autoComplete="off"
      />
      {!DeviceContext().isDesktop &&
        searchEle.current?.value !== "" &&
        searchEle.current?.value !== undefined && (
          <button className="i_close edBtn" onClick={() => reset()}>
            <i className="edel-icon-close"></i>
          </button>
        )}
    </div>
  );
};

export default Search;
